export enum CustomEvent {
  AdminProfileUpdated = 'admin-profile-updated',
  BankAccountCsvImportCompleted = 'bank-account-csv-import-completed',
  BankAccountReconciliationStartDateUpdated = 'bank-account-reconciliation-start-date-updated',
  BillCreated = 'bill-created',
  BillUpdated = 'bill-updated',
  BlockBrowserBackButtonRequested = 'block-browser-back-button-requested',
  BrowserNavigationButtonClickedAndBlocked = 'browser-back-button-clicked-and-blocked',
  ContactUpdated = 'contact-updated',
  CreateNewBillClicked = 'create-new-bill-clicked',
  EmberRouteSettled = 'ember-route-settled',
  EmberUserOrganizationsLoaded = 'ember-user-organizations-loaded',
  GlobalSearchButtonClicked = 'global-search-button-clicked',
  HashRouterLocationChanged = 'hash-router-location-changed',
  InvoiceApproved = 'invoice-approved',
  InvoiceCreated = 'invoice-created',
  InvoiceUpdated = 'invoice-updated',
  OpenCreateVatRateModalRequested = 'open-create-vat-rate-modal-requested',
  OrganizationOwnersUpdated = 'organization-owners-updated',
  OrganizationUnlocked = 'organization-unlocked',
  OrganizationSettingsUpdated = 'organization-settings-updated',
  OrganizationSettingsUpdatedInReactApp = 'organization-settings-updated-in-react-app',
  OrganizationUpdated = 'organization-updated',
  PaymentMethodsUpdated = 'payment-methods-updated',
  PaymentSaved = 'payment-saved',
  PaymentUpdated = 'payment-updated',
  QuoteCreated = 'quote-created',
  ReviewEntryDraftChanged = 'review-entry-draft-changed',
  ReviewEntryDraftFlushRequested = 'review-entry-draft-flush-requested',
  RoutingLinkClicked = 'routing-link-clicked',
  StripeIntegrationDeliverResult = 'stripe-integration-deliver-result',
  StripeIntegrationRequestResult = 'stripe-integration-request-result',
  TaxRulesetUpdated = 'tax-ruleset-updated',
  TaxRuleUpdated = 'tax-rules-updated',
  ThemeLayoutChanged = 'theme-layout-changed',
  ThemeLayoutModeChanged = 'theme-layout-mode-changed',
  TransactionCreated = 'transaction-created',
  TransactionUpdated = 'transaction-updated',
  TransactionsDaybookVoided = 'transactions-daybook-voided',
  TransactionsDaybookReversed = 'transactions-daybook-reversed',
  UploadsUpdated = 'uploads-updated',
  VatDeclarationInvalidated = 'vat-declaration-invalidated',
}
